import { FC } from 'react';

import { AiOutlineCloseCircle } from 'react-icons/ai';
import { UPLOAD_ATTACHMENTS_FORM } from 'modules/account/contact/forms/schema';
import { convertToMegabytes } from 'utils/helpers';
import { FileIcon } from 'ui/components/icon';

type UploadListItemProps = {
  item: Pick<
    UPLOAD_ATTACHMENTS_FORM['files'][0],
    'fileUrl' | 'fileName' | 'id' | 'fileSize' | 'fileThumbnail' | 'fileType'
  >;
  onDelete: (_id: string) => void;
};

const UploadListItem: FC<UploadListItemProps> = ({
  item: { fileThumbnail, fileName, id, fileSize, fileType },
  onDelete,
}) => (
  <div className="flex px-[12px] py-[8px] justify-between bg-fill-secondary items-center">
    <div className="flex items-center gap-3">
      {fileType.startsWith('image') ? (
        <img
          className="w-9 h-9 object-cover rounded-[4px]"
          src={fileThumbnail}
          alt="leapify"
        />
      ) : (
        <div className="bg-fill-primary rounded-md grid place-items-center">
          <FileIcon className="w-7 h-7 text-content" />
        </div>
      )}
      <div className="text-sm leading-[22px] tracking-[0.04em] text-secondary-dark">
        {fileName}
      </div>
    </div>
    <div className="flex items-center gap-2">
      <div className="text-xs">{convertToMegabytes(fileSize)}</div>
      <button type="button" onClick={() => onDelete(id)}>
        <AiOutlineCloseCircle className="w-[16.5px] h-[16.5px] fill-content" />
      </button>
    </div>
  </div>
);

export default UploadListItem;
